import { map, pipe, sortBy, prop, reverse } from 'ramda';
import { fullName } from '../../../common/helpers/users';

const sortByQuantity = pipe(sortBy(prop('quantity')), reverse);

const addServiceTitle = (item) => {
  item.title = `(${item.quantity}) ${item.name}`;
  return item;
};

const addBarberName = (item) => {
  item.name = pipe(
    fullName,
    name => name || 'Unassigned',
  )(item);
  return item;
};

const mapServiceSubitems = (item) => {
  item.items = map(pipe(
    addBarberName,
    addServiceTitle,
  ), item.barbers);
  return item;
};
/* eslint-enable no-param-reassign */

export const mapServiceBreakdown = pipe(
  map(pipe(
    addServiceTitle,
    mapServiceSubitems,
  )),
  sortByQuantity
);

/* eslint-disable no-param-reassign */
const addBarberTitle = (item) => {
  item.title = item.name;
  return item;
};

const mapBarberSubitems = (item) => {
  item.items = map(pipe(
    addServiceTitle,
  ), item.items);
  return item;
};
/* eslint-enable no-param-reassign */

export const mapBarberBreakdown = allBarbers => map(pipe(
  addBarberName(allBarbers),
  addBarberTitle,
  mapBarberSubitems,
));
